import { Dropzone } from "components/Dropzone/Dropzone";
import React, { useContext, useEffect, useState } from "react";

import * as styles from "./style.css";
import { ReportContext } from "contexts/reportContext";
import { Box, StyledEngineProvider } from "@mui/material";
import { useRouter } from "next/router";
import { useUser } from "@auth0/nextjs-auth0/client";

const Upload = () => {
  const router = useRouter();
  const [pdf, setPDF] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const { rawReportData, setRawReportData, setReport, setMappings } =
    useContext(ReportContext);

  const { user } = useUser();

  useEffect(() => {
    if (pdf && user) {
      const formData = new FormData();
      formData.append("file", pdf);
      setLoading(true);
      fetch("api/parser", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.error) {
            // router.push("/pricing?no_uploads=true");
            return router.push("/pricing?no_uploads=true");
          }
          setRawReportData(data.raw);
          setReport(data.parsed);
          setMappings(data.mappings);
          void router.push("/analytics");
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .finally(() => {
          console.log("finally");
          setLoading(false);
        });
    }
  }, [pdf, user, router]);

  useEffect(() => {
    if (rawReportData.length) {
      void router.push("/analytics");
    }
  }, [rawReportData]);

  return (
    <StyledEngineProvider injectFirst>
      <Box className={styles.fileUploader}>
        <Dropzone
          onChange={(data: string[][], pdfFile?: File) => {
            if (pdfFile) {
              setPDF(pdfFile);
              return;
            }
            setRawReportData(data);
          }}
          allowPdf={!!user}
          loading={loading}
          copies={{
            undropped: (
              <>
                Upload Your Statement to Get Started
                <br />
                {!user && "In order to upload PDF file, please login"}
              </>
            ),
            dropped: "File dropped",
          }}
        />
      </Box>
    </StyledEngineProvider>
  );
};

export default Upload;
